import { Query, gql } from 'apollo-angular';


import { Injectable } from '@angular/core';
import { StorefrontCategory } from './get-storefront-categories.query';

@Injectable({
  providedIn: 'root'
})
export class GetStorefrontLiteGQL extends Query<GetStorefrontLiteGQLResponse, GetStorefrontLiteGQLVariables> {
  document = gql`
    query getBasicStorefront($storefrontId: ID) {
      storefronts(storefrontIds:[$storefrontId]) {
        partnerId
        catalog {
          catalogId
          name
          categories {
            categoryId
            name
            position
            isAffiliate
          }
          products {
            productId
            name
            sku
            isActive
          }
        }
      }
    }
  `;
}

interface GetStorefrontLiteGQLVariables {
  storefrontId: string;
}

interface GetStorefrontLiteGQLResponse {
  storefronts: StorefrontLite[];
}

export interface StorefrontLite {
  partnerId: number;
  catalog: CatalogLite;
}

export interface CatalogLite {
  catalogId: string;
  name: string;
  categories: StorefrontCategory[];
  products: ProductLite[];
}

export interface ProductLite {
  productId: string;
  name: string;
  sku: string;
  isActive: boolean;
}
